import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getAdviceNoteById(context, { adviceNoteId }) {
        return axios
            .get(`/advice-notes/advice-notes/${adviceNoteId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie awizacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    saveAdviceNote(context, payload) {
        const { orderId, jobId, adviceNoteId, attachmentIds, ...adviceNoteData } = payload
        
        const adviceNotePayload = {
            supplier: adviceNoteData.supplier || null,
            estimatedPaperDeliveryDate: adviceNoteData.estimatedPaperDeliveryDate || null,
            paperType: adviceNoteData.paperType || null,
            paperWeight: adviceNoteData.paperWeight || null,
            numberOfPallets: adviceNoteData.numberOfPallets || null,
            orderId: orderId,
            jobId: jobId,
            attachmentIds: attachmentIds || []
        }

        if (adviceNoteId) {
            return axios
                .put(`/advice-notes/advice-notes/${adviceNoteId}`, adviceNotePayload)
                .then(response => {
                    return Promise.resolve(response)
                })
                .catch(error => {
                    handleApiError(error, 'Zapisanie awizacji nie powiodło się.')

                    return Promise.reject(error)
                })
        } else {
            return axios
                .post('/advice-notes/advice-notes', adviceNotePayload)
                .then(response => {
                    return Promise.resolve(response)
                })
                .catch(error => {
                    handleApiError(error, 'Zapisanie awizacji nie powiodło się.')

                    return Promise.reject(error)
                })
        }
    },
    createAdviceNoteAttachment({ commit }, { formData }) {
        return axios
            .post('/advice-notes/advice-notes/attachments', formData)
            .then(response => {

                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Dodano załącznik.'
                }, { root: true })
                
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie załącznika nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteAdviceNoteAttachment(context, { attachmentId }) {
        return axios
            .delete(`/advice-notes/advice-notes/attachments/${attachmentId}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie załącznika nie powiodło się.')

                return Promise.reject(error)
            })
    }
}

